import type { Craft } from "@/shared/work-orders-modals/models/Craft";
import { useState } from "react";
import { get } from "react-hook-form";
import { useTaskListContext } from "../context/taskListContext";
import { getCrafts } from "../repositorie/TaskListRepositorie";

export const useGetDataFromAPI = () => {
	const {
		state: {},
		actions: {
			setCraftCodesTaskList,
			setCraftSearchId,
			setTypesCodesTaskList,
			setTypeCode,
		},
	} = useTaskListContext();

	const GetCraftFromAPI = () => {
		getCrafts().then((res: any) => {
			if (res !== undefined) {
				let craftSource = get(res, "data.tables[0].rows", []);
				craftSource?.forEach((row: any) => {
					row.id = row.CraftId;
					row.description = row.CraftName;
					row.color = row.Color;
				});

				craftSource = craftSource?.map(({ id, description, color }: Craft) => ({
					id,
					description,
					color,
				}));
				craftSource.push({ id: "A", description: "All crafts" });
				setCraftCodesTaskList(craftSource);
				setCraftSearchId("A");
			}
		});

		const typeSource = [];
		typeSource.push({ id: "PM", description: "PM" });
		typeSource.push({ id: "RM", description: "RM" });
		typeSource.push({ id: "A", description: "All types" });
		setTypesCodesTaskList(typeSource as any);
		setTypeCode("A");
	};

	return { GetCraftFromAPI };
};
